import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSliderChange } from '@angular/material/slider';
import { MatRadioChange } from '@angular/material/radio';
import { DisplaySettings } from '../display-settings';
import * as settings from '../../common/settings';
import * as aspSettings from '../../asp/aspSettings';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { Animations } from '@core_n/Animations';

@Component({
  selector: 'plots-settings',
  templateUrl: './plots-settings.component.html',
  styleUrls: ['../display-filter.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})
export class PlotsSettingsComponent extends ZIndexMngr implements AfterViewInit{

  static DIALOG_ID = "plotsSettings";

  plotTrailLength = settings.userSettings.plotTrailLength;
  plotDisplaySymbol = settings.userSettings.plotDisplaySymbol ? 'symbol' : 'letter';

  constructor(public dialogRef: MatDialogRef<PlotsSettingsComponent>,
    elementRef: ElementRef) {
    super(elementRef);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    })
  }

  onPlotTrailSliderChanged(event: MatSliderChange) {
    settings.userSettings.setPlotTrailLength(event.value);
  }

  onPlotDisplayRadioChanged(event: MatRadioChange) {
    settings.userSettings.setPlotDisplaySymbol(event.value == 'symbol');
  }

  plotTrailMaxLength() {
    return aspSettings.plotsHistory(); // sec
  }

}
